import { EGeoSuggestStatus, GeoSuggestDependencies, IGeoSuggestResult } from './types';
import { fetchSuggest, ISuggestRequest, TSuggestResponse } from '../../repositories/geo-suggest/v2/suggest';
import { ResponseError } from 'shared/errors';
import { prepareGeoSuggest } from 'shared/mappers/prepareGeoSuggest';

const DOMAIN = 'critical.geoSuggest';

export const getGeoSuggestions = async (
  dependencies: GeoSuggestDependencies,
  parameters: ISuggestRequest,
): Promise<IGeoSuggestResult> => {
  const { httpApi, logger } = dependencies;

  try {
    const { statusCode, response }: TSuggestResponse = await fetchSuggest({
      httpApi,
      parameters,
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: DOMAIN,
        message: response.message || 'geoSuggest error',
        details: {
          error: JSON.stringify(response.errors),
        },
      });
    }

    return prepareGeoSuggest(response) as IGeoSuggestResult;
  } catch (error) {
    logger.error(error, {
      degradation: 'Запрос гео-саджестов',
      domain: DOMAIN,
      microserviceName: 'geo-suggest',
      pathApi: '/public/v2/suggest/',
      parameters: JSON.stringify(parameters),
    });

    return {
      data: {
        suggestions: {},
        sortOrder: [],
      },
      message: 'geo-suggest /v2/suggest/ rejection error',
      status: EGeoSuggestStatus.CriticalError,
    };
  }
};
